// extracted by mini-css-extract-plugin
export default {"root":"MenuLabel_root__vC8Wv","clickedWithMouse":"MenuLabel_clickedWithMouse__n+C1n","menuButton":"MenuLabel_menuButton__8WhGt","isOpen":"MenuLabel_isOpen__gDCZN"};